export const MAX_AUDIO_MB = 25;
export const ALLOWED_AUDIO_EXTENSION = ["m4a", "mp3", "mp4", "wav", "webm"];
